// AUTO-GENERATED by scripts/generate-contracts.mjs from the .md sidecar.
// Hand edits will be overwritten on the next run. To customise this
// component's contract (add actions, structured props, custom control
// kinds, glyph pickers), remove this file's auto-generated marker and
// hand-author it — the generator skips files without the marker.

import { z } from "zod";
import { contract } from "@gradeui/contracts";

export const DataViewContract = contract({
  name: "DataView",
  description: "One dataset, drawn as a table, a list of cards, or a grid — without re-typing the TanStack boilerplate (sortable headers, flexRender, selection, view switch) on every page. Hand it data + a columns schema; columns declare a `type` (badge/tags/number/currency/percent/date/boolean/url/text) that DataView renders, with a `cell` override for bespoke cells (avatars, relations). The view toggle can live anywhere — `useDataView()` holds the state so a `<DataViewToggle>` or `<DataViewColumns>` in a page header drives a `<DataView>` lower down. Mark a column `pinned=\"left\"` (with a `width`) for a fixed column and `stickyHeader` to freeze the header. For a single record's fields use PropertyList; for the raw table primitive use Table.",
  import: "@gradeui/ui",
  aliases: ["data view","data table","datatable","data grid","dataview","table view","card view","grid view","list view","gallery","records list","master list","tanstack table","sortable table","column visibility","pinned column","frozen column","sticky header","view switcher"],
  composesWith: ["Table","Card","Badge","Avatar","ToggleGroup","DropdownMenu","PropertyList","Combobox"],
  styleDefaults: {"TableView":"h-3 w-3 transition-opacity"},
  props: {
  "data": {
      schema: z.unknown(),
      design: "plumbing",
      description: "the rows",
  },
  "columns": {
      schema: z.unknown(),
      design: "plumbing",
      description: "the schema; one list drives table, cards, and grid",
  },
  "getRowId": {
      schema: z.unknown().optional(),
      design: "plumbing",
      description: "defaults to row.id",
  },
  "view": {
      schema: z.enum(["table", "cards", "grid"]).optional(),
      design: "knob",
      description: "controlled or uncontrolled view",
  },
  "defaultView": {
      schema: z.enum(["table", "cards", "grid"]).optional(),
      design: "knob",
      description: "controlled or uncontrolled view",
  },
  "onViewChange": {
      schema: z.enum(["table", "cards", "grid"]).optional(),
      design: "event",
      description: "controlled or uncontrolled view",
  },
  "views": {
      schema: z.unknown().optional(),
      design: "plumbing",
      description: "allowed views; one entry = single view, no toggle",
  },
  "activeId": {
      schema: z.string().optional(),
      design: "content",
      description: "the selected row; click emits it",
  },
  "defaultActiveId": {
      schema: z.string().optional(),
      design: "content",
      description: "the selected row; click emits it",
  },
  "onActiveChange": {
      schema: z.string().optional(),
      design: "event",
      description: "the selected row; click emits it",
  },
  "sorting": {
      schema: z.unknown().optional(),
      design: "plumbing",
      description: "TanStack SortingState",
  },
  "defaultSorting": {
      schema: z.unknown().optional(),
      design: "plumbing",
      description: "TanStack SortingState",
  },
  "onSortingChange": {
      schema: z.unknown().optional(),
      design: "event",
      description: "TanStack SortingState",
  },
  "columnVisibility": {
      schema: z.unknown().optional(),
      design: "plumbing",
      description: "which fields show",
  },
  "defaultColumnVisibility": {
      schema: z.unknown().optional(),
      design: "plumbing",
      description: "which fields show",
  },
  "onColumnVisibilityChange": {
      schema: z.unknown().optional(),
      design: "event",
      description: "which fields show",
  },
  "pageSize": {
      schema: z.number().optional(),
      design: "knob",
      description: "rows per page. Unset = no pagination (every row renders, the page scrolls). Set it for a history that grows: the table stops scrolling inside itself and grows a pager instead.",
  },
  "stickyHeader": {
      schema: z.boolean().optional(),
      design: "knob",
      description: "freeze the header row on scroll",
  },
  "toolbar": {
      schema: z.boolean().optional(),
      design: "knob",
      description: "render the built-in columns menu + view toggle above the view",
  },
  "renderCard": {
      schema: z.unknown().optional(),
      design: "plumbing",
      description: "override card / grid tiles",
  },
  "emptyMessage": {
      schema: z.unknown().optional(),
      design: "plumbing",
  },
  },
});
